module.exports = __webpack_public_path__ + "static/img/2023_9_8_12.a8b5b6b8.a8b5b6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_12.a8b5b6b8.jpg
// module id = gltc
// module chunks = 0